import axios from "axios";
import { getUrlApi } from "../utils/util";

class ShoppingCartService {
    async getShoppingCart() {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.get(`${url}`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async getCountLines() {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.get(`${url}/count`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async addProduct(productId, quantity) {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.get(`${url}/add/${productId}?quantity=${quantity}`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async create(shoppingCart) {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.post(`${url}/create`, shoppingCart, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async save(shoppingCart) {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.post(`${url}/save`, shoppingCart, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async convert(shoppingCart) {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.post(`${url}/convert`, shoppingCart, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async conclude(shoppingCart) {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.post(`${url}/conclude`, shoppingCart, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async getPaymentMethods() {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.get(`${url}/paymentmethods`, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }

    async pay(order, type, token) {
        var url = `${await getUrlApi()}/shoppingcart`;
        return axios.post(`${url}/pay/${order}/${type}/${token}`, "", {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorization"),
            },
        });
    }
}

export default new ShoppingCartService();
